import { render, staticRenderFns } from "./ndr2.vue?vue&type=template&id=3c37bfbf&scoped=true"
import script from "./ndr2.vue?vue&type=script&lang=js"
export * from "./ndr2.vue?vue&type=script&lang=js"
import style0 from "./ndr2.vue?vue&type=style&index=0&id=3c37bfbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c37bfbf",
  null
  
)

export default component.exports